import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../../theme';
import { FA_SELECTOR } from '../../../styles/variables';
import { absolute, heightExtendingError } from '../../../styles/mixins';

export const useTemplatesFormDrawerStyles = createStyles(({ token }) => ({
  content: {
    position: 'relative',
    height: '100%',

    [`@media (min-width: ${token.screenLGMin}px)`]: {
      width: 560,
      margin: 'auto',
    },
    [`@media (max-width: ${token.screenMDMax}px)`]: {
      margin: `0 ${ThemeSpaces.SPACE_NORM}px`,
    },
  },
  templateDrawerForm: {
    ...absolute(0),
    zIndex: 2,
    backgroundColor: ThemeColors.COLOR_WHITE3,
    paddingTop: ThemeSpaces.SPACE_NORM_20,
    paddingBottom: ThemeSpaces.SPACE_NORM,

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 0,
      backgroundColor: ThemeColors.COLOR_WHITE3,
    },

    '.TemplateDrawerForm-Title': {
      marginTop: ThemeSpaces.SPACE_NORM,
      fontWeight: 300,

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        fontSize: 32,
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        fontSize: token.fontSizeHeading3,
      },
    },

    '.TemplateDrawerForm-Controls': {
      '.InlineLink': {
        color: ThemeColors.COLOR_RED,
        fontWeight: 500,

        // Firefox renders in a buggy way if a parent has underline and a child contains text
        '> *': {
          textDecoration: 'underline',
        },
        [`> ${FA_SELECTOR}`]: {
          textDecoration: 'none',
          marginTop: -1,
        },
      },

      '.IconButton': {
        color: ThemeColors.COLOR_RED,
        fontSize: token.fontSize,
        marginLeft: ThemeSpaces.SPACE_NORM,
      },

      '> .ant-col': {
        display: 'flex',
        alignItems: 'center',

        '> *': {
          marginRight: ThemeSpaces.SPACE_NORM,

          '&:last-child': {
            marginRight: 0,
          },
        },
      },

      '.ant-btn': {
        fontWeight: 500,
      },
    },
  },
  formError: {
    '&&': {
      ...heightExtendingError(token),
    },
  },
  templateDrawerFormDivider: {
    margin: `${ThemeSpaces.SPACE_NORM}px 0`,
  },
}));
